// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ol-viewport .ol-scale {\n\tleft: .5em;\n\tbottom: 2.5em;\n\ttext-align: center;\n\t-webkit-transform: scaleX(.8);\n\t-webkit-transform-origin: 0 0;\n\ttransform: scaleX(.8);\n\ttransform-origin: 0 0;\n}\n.ol-viewport .ol-scale input {\n\tbackground: none;\n    border: 0;\n    width: 8em;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
